<ba-container *ngIf="isAuthDone" (accountCreated)="accountCreated.emit($event)"></ba-container>
<ng-container *ngIf="authError"> No se pudo realizar la autenticación, revisa las credenciales. </ng-container>


<iframe title="newrelic" [src]="iframeUrl" hidden #iframeNewrelicRef></iframe>
